import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { FlexBox } from '../../box';
import { Link } from '../../link';
const MultiSelectionComponent = (props) => (_jsxs(FlexBox, { padding: [1, 1.5], borderBottom: 1, borderColor: "divider", hAlign: "space-between", children: [_jsx(Link, { ...props.selectAll, underline: "hover", color: "primary" }), _jsx(Link, { ...props.selectNone, underline: "hover" })] }));
function useMultiselection(props) {
    if (props.multipleConfig && props.multiple && Array.isArray(props.value)) {
        return {
            MultiSelection: MultiSelectionComponent,
            multiSelectionProps: {
                selectAll: {
                    children: props.multipleConfig.selectAll,
                    onClick(e) {
                        props.onChange?.(props.options, e, 'selectOption');
                    }
                },
                selectNone: {
                    children: props.multipleConfig.selectNone,
                    onClick(e) {
                        props.onChange?.([], e, 'selectOption');
                    }
                }
            }
        };
    }
    return { MultiSelection: null, multiSelectionProps: null };
}
export default { useMultiselection };
